export const SET_ONBOARD_STEP = "app/ONBOADING/SET_ONBOARD_STEP";
export const SET_ONBOARD_INFO = "app/ONBOADING/SET_ONBOARD_INFO";
export const SET_ONBOARDING_DATA = "app/ONBOADING/SET_ONBOARDING_DATA";

export const CREATE_CUSTOMER = "app/ONBOADING/CREATE_CUSTOMER";
export const CREATE_CUSTOMER_SUCCESS = "app/ONBOADING/CREATE_CUSTOMER_SUCCESS";
export const CREATE_CUSTOMER_FAILURE = "app/ONBOADING/CREATE_CUSTOMER_FAILURE";

export const UPLOAD_DOCUMENT = "app/ONBOADING/UPLOAD_DOCUMENT";
export const UPLOAD_DOCUMENT_SUCCESS = "app/ONBOADING/UPLOAD_DOCUMENT_SUCCESS";
export const UPLOAD_DOCUMENT_FAILURE = "app/ONBOADING/UPLOAD_DOCUMENT_FAILURE";

export const UPDATE_PERIOD_INFO = "app/ONBOADING/UPDATE_PERIOD_INFO";
export const UPDATE_PERIOD_INFO_SUCCESS =
  "app/ONBOADING/UPDATE_PERIOD_INFO_SUCCESS";
export const UPDATE_PERIOD_INFO_FAILURE =
  "app/ONBOADING/UPDATE_PERIOD_INFO_FAILURE";

export const SET_PERMISSIONS = "app/ONBOADING/SET_PERMISSIONS";
export const SET_PERMISSIONS_SUCCESS = "app/ONBOADING/SET_PERMISSIONS_SUCCESS";
export const SET_PERMISSIONS_FAILURE = "app/ONBOADING/SET_PERMISSIONS_FAILURE";

export const SET_ALLOWANCE = "app/ONBOADING/SET_ALLOWANCE";
export const SET_ALLOWANCE_SUCCESS = "app/ONBOADING/SET_ALLOWANCE_SUCCESS";
export const SET_ALLOWANCE_FAILURE = "app/ONBOADING/SET_ALLOWANCE_FAILURE";

export const ONBOARD_EMPLOYEE = "app/ONBOADING/ONBOARD_EMPLOYEE";
export const ONBOARD_EMPLOYEE_SUCCESS =
  "app/ONBOADING/ONBOARD_EMPLOYEE_SUCCESS";
export const ONBOARD_EMPLOYEE_FAILURE =
  "app/ONBOADING/ONBOARD_EMPLOYEE_FAILURE";

export const UPDATE_BASIC_INFO = "app/ONBOADING/UPDATE_BASIC_INFO";
export const UPDATE_BASIC_INFO_SUCCESS =
  "app/ONBOADING/UPDATE_BASIC_INFO_SUCCESS";
export const UPDATE_BASIC_INFO_FAILURE =
  "app/ONBOADING/UPDATE_BASIC_INFO_FAILURE";

export const GET_DOCUMENTS = "app/ONBOADING/GET_DOCUMENTS";
export const GET_DOCUMENTS_SUCCESS = "app/ONBOADING/GET_DOCUMENTS_SUCCESS";
export const GET_DOCUMENTS_FAILURE = "app/ONBOADING/GET_DOCUMENTS_FAILURE";

export const SET_FILE_LIST = "app/ONBOADING/SET_FILE_LIST";

export const SET_ACCOUNTING_TYPE = "app/ONBOADING/SET_ACCOUNTING_TYPE";

export const UPLOAD_COMMON_DOCUMENT = "app/ONBOADING/UPLOAD_COMMON_DOCUMENT";
export const UPLOAD_COMMON_DOCUMENT_SUCCESS =
  "app/ONBOADING/UPLOAD_COMMON_DOCUMENT_SUCCESS";
export const UPLOAD_COMMON_DOCUMENT_FAILURE =
  "app/ONBOADING/UPLOAD_COMMON_DOCUMENT_FAILURE";

export const GET_COMMON_DOCUMENTS = "app/ONBOADING/GET_COMMON_DOCUMENTS";
export const GET_COMMON_DOCUMENTS_SUCCESS =
  "app/ONBOADING/GET_COMMON_DOCUMENTS_SUCCESS";
export const GET_COMMON_DOCUMENTS_FAILURE =
  "app/ONBOADING/GET_COMMON_DOCUMENTS_FAILURE";

export const DOWNLOAD_DOC = "app/ONBOADING/DOWNLOAD_DOC";
export const DOWNLOAD_DOC_SUCCESS = "app/ONBOADING/DOWNLOAD_DOC_SUCCESS";
export const DOWNLOAD_DOC_FAILURE = "app/ONBOADING/DOWNLOAD_DOC_FAILURE";
